/**------------- Sections Wrapper constants -------------**/

/*  General  */
export const SECTIONS_WRAPPER_CLASS_NAME =
	"sections-wrapper";
